document.addEventListener('alpine:init', () => { 
    Alpine.data('ProductCard', (id) => ({
      id,
      mainProduct: {}, // { id, title, options, variants }
      optionsName: [], // ['Color', 'Size']
      options: {}, // { Color: ['Red', 'Blue'], Size: ['S', 'M'] }
      variants: [], // [{ id, title, options: { Color: 'Red', Size: 'M' }, ... }]
      selectedOptions: {}, // { Color: 'Red', Size: 'M' }
      selectedVariant: null,
      finalVariantIdsMap: {},
      actualPrice: 0, // The currently displayed price based on selection
      typePurchase: 'onetime', // 'onetime' or 'autodeliver'
      selectedPlanId: null, // Selected selling plan ID
      alpineQuantity: 1, // Reference to quantity component
  
      /**
       * Initialize the component with default data
       */
      init() {
        this.parseProductJson();      // Parse the product JSON from the DOM
        this.mapOptions();            // Extract all unique option values
        this.mapVariants();           // Map all variants with named option objects
        this.selectDefaultOptions();  // Select the default variant and options

        this.purchaseTypeHandler();   // Setup purchase type change handler
        this.quantityChange();        // Bind custom quantity swatch changes
        this.updatePrice();           // Initialize the price display
        this.bindVariantChangeEvents(); // Keep price in sync on variant change
        this.updatePurchaseOptionPrices(); // Initialize frequency prices
      },
  
      /** 
       * Parse the product JSON from a DOM reference
       */
      parseProductJson() {
        const productData = JSON.parse(this.$refs.productDataJson.textContent);
        this.mainProduct = productData;
        console.log('this.mainProduct', this.mainProduct);
      },
  
      /**
       * Initialize the component with a new product
       * @param {Object} product - The new product object
       */
      initNewProduct(product) {
        this.mainProduct = product;
        this.init();
      },
  
      /**
       * Map all available product options and their unique values
       */ 
      mapOptions() { 
        this.options = {};
        this.optionsName = [];
      
        this.mainProduct.options.forEach((option, index) => {
          const key = `option${index + 1}`;
          this.optionsName.push(option);
          this.options[key] = this.mainProduct.variants
            .map(v => v.options[index])
            .filter((value, i, arr) => arr.indexOf(value) === i);
        });
      
        console.log('this.options', this.options);
        console.log('this.optionsName', this.optionsName);
      },
  
      /**
       * Create a normalized list of variants with key-value pair options
       */
      mapVariants() {
        this.variants = this.mainProduct.variants.map(variant => {
          const optionsObj = {};
          this.mainProduct.options.forEach((opt, i) => {
            const key = `option${i + 1}`;
            optionsObj[key] = variant.options[i];
          });
          return {
            ...variant,
            optionsMapped: optionsObj,
          };
        });
        console.log('this.variants', this.variants);
      },
  
    /**
     * Set the default selected options.
     * If the URL contains a ?variant=ID, use that variant's options.
     * Otherwise, fallback to the first available variant.
     */
    selectDefaultOptions() {
        if (this.variants.length === 0) return;
    
        const urlParams = new URLSearchParams(window.location.search);
        const variantIdFromUrl = urlParams.get('variant');
    
        if (variantIdFromUrl && /^\d+$/.test(variantIdFromUrl)) {
            const matchedVariant = this.variants.find(v => v.id.toString() === variantIdFromUrl);
        
            if (matchedVariant) {
                this.selectedOptions = { ...matchedVariant.optionsMapped };
                this.selectedVariant = matchedVariant;
                const lastKey = `option${this.optionsName.length}`;
                this.updateFinalVariantMap(lastKey);
                console.log('Selected from URL:', matchedVariant);
                return;
            }
        }
    
        // fallback if variant param not found or invalid
        this.selectedOptions = { ...this.variants[0].optionsMapped };
        this.selectedVariant = this.variants[0];
        const lastKey = `option${this.optionsName.length}`;
        this.updateFinalVariantMap(lastKey);
        console.log('Selected default variant:', this.selectedVariant);
    },

    
  
        /**
         * Update the selected option for a given option name
         * @param {String} name - Option name (e.g. "Option1")
         * @param {String} value - Selected value (e.g. "Red")
         */
        selectOption(name, value) {
            this.selectedOptions[name] = value;
            this.selectVariant();
            const lastKey = `option${this.optionsName.length}`;
            this.updateFinalVariantMap(lastKey);
            console.log('this.selectedOptions', this.selectedOptions);
        },
  
        /**
         * Find and set the selected variant based on current selectedOptions
         */
        selectVariant() {
            this.selectedVariant = this.variants.find(v => {
                return Object.entries(this.selectedOptions).every(([key, value]) => {
                return v.optionsMapped[key] === value;
                });
            }) || null;

            // Update the URL with the selected variant ID
            if (this.selectedVariant) {
                const url = new URL(window.location.href);
                url.searchParams.set('variant', this.selectedVariant.id);
                window.history.replaceState({}, '', url);
                console.log('Selected variant:', this.selectedVariant);
            }
        },

        /**
         * Get mapping of option values to variant IDs for the final option level.
         * This can be used to render buttons with attached variant IDs.
         * @param {String} optionKey - like "option3"
         * @returns {Object} - { "Black": 1234567890, "White": 1234567891 }
         */
        updateFinalVariantMap(optionKey) {
          console.log('Updating variant map for:', optionKey);
        
          const filtered = this.variants.filter(v => {
            return Object.entries(this.selectedOptions).every(([key, value]) => {
              return key === optionKey || v.optionsMapped[key] === value;
            });
          });
        
          if (filtered.length === 0) {
            this.finalVariantIdsMap[optionKey] = {};
            return;
          }
        
          const map = {};
          filtered.forEach(v => {
            const value = v.optionsMapped[optionKey];
            map[value] = {
              id: v.id,
              available: v.available
            };
          });
        
          this.finalVariantIdsMap = {
            ...this.finalVariantIdsMap,
            [optionKey]: map
          };
        },

        /**
       * Function to check availability of a variant by its ID
       */
        calcCustomQuantity(direction) {
          const inputsQuantity = document.querySelectorAll('.custom_product__quantity-item');


          // direction = 'plus' или 'minus'
          if (direction === 'plus') {
            this.alpineQuantity++; 
            inputsQuantity.forEach(input => {
              let input_block = input.querySelector('input.custom_product__quantity-item-checkbox');
              let input_start_value = input_block.getAttribute('data-start-value') || 0;
              input_block.value = input_start_value * this.alpineQuantity;
            });
          } else if (direction === 'minus' && this.alpineQuantity > 1) {
            this.alpineQuantity--;
            inputsQuantity.forEach(input => {
              let input_block = input.querySelector('input.custom_product__quantity-item-checkbox');
              let input_start_value = input_block.getAttribute('data-start-value') || 0;
              input_block.value = input_start_value * this.alpineQuantity;
            });
          }
        },

        quantityChange() {
          const quantityInputs = document.querySelectorAll('.custom_product__quantity-item-checkbox');
          if (!quantityInputs.length) return;

          const setVariantFromInput = (input) => {
            if (!input || !input.checked) return;
            const variantId = input.dataset.variantId;
            if (!variantId) return;

            const matchedVariant = this.variants.find(v => v.id == variantId);
            if (matchedVariant) {
              this.selectedVariant = matchedVariant;
              this.emitVariantPriceChange(matchedVariant);
            }

            const form = input.closest('form') || document;
            const variantSelect = form.querySelector('[data-product-select]');
            if (variantSelect && variantSelect.value !== variantId) {
              variantSelect.value = variantId;
              variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
          };

          quantityInputs.forEach(input => {
            if (input.checked) {
              setVariantFromInput(input);
            }
            input.addEventListener('change', () => {
              setVariantFromInput(input);
              this.updatePrice();
              this.updatePurchaseOptionPrices();
            });
          });
        },

        bindVariantChangeEvents() {
          const updateFromVariant = (variant) => {
            if (!variant || !variant.id) return;
            const matchedVariant = this.variants.find(v => v.id == variant.id);
            if (matchedVariant) {
              this.selectedVariant = matchedVariant;
            }
            this.updatePrice();
            this.updatePurchaseOptionPrices();
            this.emitVariantPriceChange(variant);
          };

          document.addEventListener('variant:change', (event) => {
            if (event.detail && event.detail.variant) {
              updateFromVariant(event.detail.variant);
            }
          });

          document.addEventListener('variantChange', (event) => {
            if (event.detail && event.detail.variant) {
              updateFromVariant(event.detail.variant);
            }
          });

          document.addEventListener('variantPriceChange', (event) => {
            if (event.detail && event.detail.variant) {
              updateFromVariant(event.detail.variant);
            }
          });

          document.addEventListener('change', (event) => {
            if (event.target && event.target.matches('[data-product-select]')) {
              const variantId = event.target.value;
              const matchedVariant = this.variants.find(v => v.id == variantId);
              if (matchedVariant) {
                this.selectedVariant = matchedVariant;
                this.updatePrice();
                this.updatePurchaseOptionPrices();
                this.emitVariantPriceChange(matchedVariant);
              }
            }
          });
        },

        emitVariantPriceChange(variant) {
          const container = this.$refs?.product_card_element || document;
          if (!variant || !container) return;
          container.dispatchEvent(new CustomEvent('variantPriceChange', {
            detail: { variant },
            bubbles: true
          }));
        },

        updatePurchaseOptionPrices() {
          const variant = this.selectedVariant;
          if (!variant) return;

          const container = this.$refs?.product_card_element || document;
          const formatMoney = (cents) => {
            if (window.theme && window.theme.Currency && window.theme.strings) {
              return window.theme.Currency.formatMoney(cents, window.theme.strings.moneyFormat);
            }
            return `$${(cents / 100).toFixed(2)}`;
          };

          // One-time price
          container.querySelectorAll('.js-onetime-price').forEach(el => {
            el.textContent = formatMoney(variant.price);
          });

          // Compare at / original price
          const comparePrice = variant.compare_at_price;
          container.querySelectorAll('.product__price--compare, .grid-product__price--original').forEach(el => {
            if (el.classList.contains('js-onetime-price') || el.classList.contains('js-autodeliver-price')) {
              return;
            }
            if (comparePrice && comparePrice > variant.price) {
              el.textContent = formatMoney(comparePrice);
            } else {
              el.textContent = '';
            }
          });

          // Autodeliver price
          const planSelect = container.querySelector('.js-product-selling-plan, select[name="selling_plan"]');
          const selectedPlanId = planSelect ? parseInt(planSelect.value) : null;
          let autodeliverPriceCents = variant.price;

          if (selectedPlanId) {
            const allocation = (variant.selling_plan_allocations || []).find(a => a.selling_plan_id == selectedPlanId);
            if (allocation && allocation.price) {
              autodeliverPriceCents = allocation.price;
            } else {
              const sellingPlanGroups = this.mainProduct?.selling_plan_groups || [];
              let selectedPlan = null;
              sellingPlanGroups.forEach(group => {
                const match = (group.selling_plans || []).find(p => p.id == selectedPlanId);
                if (match) selectedPlan = match;
              });
              if (selectedPlan && selectedPlan.price_adjustments && selectedPlan.price_adjustments[0]) {
                const adjustment = selectedPlan.price_adjustments[0];
                if (adjustment.value_type === 'percentage') {
                  autodeliverPriceCents = Math.max(0, Math.round(variant.price - (variant.price * adjustment.value / 100)));
                } else if (adjustment.value_type === 'fixed_amount') {
                  autodeliverPriceCents = Math.max(0, variant.price - adjustment.value);
                }
              }
            }
          }

          container.querySelectorAll('.js-autodeliver-price').forEach(el => {
            el.textContent = formatMoney(autodeliverPriceCents);
          });
        },

        purchaseTypeHandler() {
          const purchaseTypeInputs = document.querySelectorAll('input[name="purchase_type"]');
          if (!purchaseTypeInputs.length) {
            this.typePurchase = 'onetime';
          }

          purchaseTypeInputs.forEach(input => {
            if (input.checked) {
              this.typePurchase = input.value;
            }
            input.addEventListener('change', () => {
              if (input.checked) {
                this.typePurchase = input.value;
              }
              this.updatePrice();
            });
          });

          const selectEl = document.querySelector('.js-product-selling-plan');
          if (!selectEl) return;
          this.selectedPlanId = selectEl.querySelector('option:checked').value;
          console.log('Selected plan ID option:checked:', this.selectedPlanId);
          selectEl.addEventListener('change', (event) => {
            const selectedOption = event.target.querySelector('option:checked');
            this.selectedPlanId = selectedOption?.value || null;                    
            console.log('Selected plan ID:', this.selectedPlanId);

            this.updatePrice(planId);
          });
        },

        updatePrice() {
          const inputsQuantity = document.querySelectorAll('.custom_product__quantity-item');
          const subtitlePriceEl = document.querySelector('#custom_product__quantity-per-can');

          inputsQuantity.forEach(input => {
            let input_block = input.querySelector('input.custom_product__quantity-item-checkbox');
            let input_value = input_block?.value || 1;
            let input_discount = input_block.getAttribute('data-callout-discount') || 0;
            let input_price_per_item = input.querySelector('.custom_product__quantity-item-per-can');
            
            // FIXED: Extract pack size from the metaobject field text (e.g., "12 PACK", "24 PACK", "48 PACK")
            let pack_size = null;
            
            // Prefer explicit pack size from data attributes
            const dataPackSize = parseInt(input_block.getAttribute('data-pack-size'));
            if (!isNaN(dataPackSize) && dataPackSize > 0) {
              pack_size = dataPackSize;
            }

            // Try to find the pack size label/text within the input container
            // This could be in a label, span, or any text content associated with this option
            if (!pack_size) {
              const labelText = input.textContent || input.innerText || '';
              const packSizeMatch = labelText.match(/(\d+)\s*pack/i);
            
              if (packSizeMatch) {
                pack_size = parseInt(packSizeMatch[1]);
              }
            }
            
            // Final fallback: use input_value
            if (!pack_size || isNaN(pack_size)) {
              pack_size = parseInt(input_value) || 12; // default to 12 if all else fails
            }
            
            // The pack_size IS the number of cans - don't multiply by input_value
            let number_items_per_pack = pack_size;



            const basePrice = (this.selectedVariant?.price || 0) / 100;
            this.actualPrice = basePrice;

            if (this.typePurchase === 'autodeliver') {
              const sellingPlanGroups = this.mainProduct?.selling_plan_groups || [];
              const discountPlansProduct = sellingPlanGroups.find(g => g.app_id === "SKIO");
              const currentPlan = discountPlansProduct?.selling_plans?.find(p => p.id == this.selectedPlanId);
              // Precentage or fixed amount
              const discountPlanPercent = currentPlan?.price_adjustments?.[0]?.value || 0;

              const allocations = this.selectedVariant?.selling_plan_allocations || [];
              const selectedAllocation = allocations.find(a => a.selling_plan_id == this.selectedPlanId);

              if (selectedAllocation && currentPlan) {
                if (currentPlan.adjustment_type === 'percentage') {
                  this.actualPrice = basePrice - (basePrice * discountPlanPercent / 100);
                } else if (currentPlan.adjustment_type === 'fixed_amount') {
                  this.actualPrice = basePrice - (discountPlanPercent / 100);
                } else {
                  this.actualPrice = selectedAllocation.price / 100;
                }
              }
            }

            const inputVariantPriceCents = parseInt(input_block?.dataset?.variantPrice || 0, 10);
            const perCanPriceBase = inputVariantPriceCents > 0
              ? (inputVariantPriceCents / 100)
              : this.actualPrice;
            const pricePerCan = (perCanPriceBase / number_items_per_pack).toFixed(2);

            if (subtitlePriceEl && input_block.checked && !subtitlePriceEl.textContent.trim()) {
              subtitlePriceEl.innerHTML = `$${pricePerCan} / can`;
            }
            input_block.addEventListener('change', () => {
              if (subtitlePriceEl && input_block.checked && !subtitlePriceEl.textContent.trim()) {
                subtitlePriceEl.innerHTML = `$${pricePerCan} / can`;
              }
            });
            
            if (input_price_per_item) {
              if (!input_price_per_item.textContent.trim()) {
                input_price_per_item.innerHTML = `$${pricePerCan} / can`;
              }
            }
          });
        },

        parsePrice(priceString) {
          if (!priceString) return 0;
          const cleaned = priceString.replace(/[^0-9.,]/g, '').replace(',', '.');
          console.log('Parsed price:', cleaned);
          return parseFloat(cleaned) || 0;
        }
    }));
  });